import { videoUrl } from '@helpers/cloudinary';
import { imageUrl } from '@helpers/image';
import { ReactComponent as SvgPlayCircle } from '@img/icons/play-circle.svg';
import Modal from '@stories/Components/Misc/Modal/Modal';
import * as React from 'react';
import S from './HomepageHeroBannerVideo.styles';
import { withMotionMax } from '@hoc/withMotionMax';
const HomepageHeroBannerVideo = (props) => {
    const refVideo = React.useRef(null);
    const refTitle = React.useRef(null);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [outOfContainer, setOutOfContainer] = React.useState(false);
    React.useEffect(() => {
        const handleScroll = () => {
            const titleBottom = refTitle.current?.getBoundingClientRect().bottom ?? 0;
            const videoBottom = refVideo.current?.getBoundingClientRect().bottom ?? 0;
            setOutOfContainer(titleBottom > videoBottom);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (React.createElement(S.Container, { layout: "fullWidth" },
        React.createElement(S.Video, { ref: refVideo, autoPlay: !modalOpen, loop: true, muted: true, playsInline: true, poster: props.previewImage
                ? imageUrl(props.previewImage, { width: 1920, height: 1080 })
                : videoUrl(props.videoId, { format: 'jpg' }) },
            React.createElement("source", { type: "video/webm", src: videoUrl(props.videoId, { format: 'webm' }) }),
            React.createElement("source", { type: "video/mp4", src: videoUrl(props.videoId, { format: 'mp4' }) })),
        props.tint > 0 && (React.createElement(S.Tint, { "aria-hidden": true, style: { '--amount': props.tint } })),
        React.createElement(S.TitleWrapper, null,
            React.createElement(S.Title, { ref: refTitle, "data-out-container": outOfContainer }, props.title)),
        props.fullVideoId && (React.createElement(React.Fragment, null,
            React.createElement(S.Cta, { type: "button", onClick: (event) => {
                    event.preventDefault();
                    setModalOpen(true);
                    refVideo.current?.pause();
                } },
                React.createElement(SvgPlayCircle, null),
                props.ctaText),
            React.createElement(Modal, { ariaLabel: "Full Video Player Modal", isOpen: modalOpen, closeOnBackground: true, showBackground: true, showClose: true, onClose: () => {
                    setModalOpen(false);
                    refVideo.current?.play();
                } },
                React.createElement(S.ModalVideo, { autoPlay: true, controls: true, playsInline: true, poster: props.previewImage
                        ? imageUrl(props.previewImage, { width: 1920, height: 1080 })
                        : videoUrl(props.fullVideoId, { format: 'jpg' }) },
                    React.createElement("source", { type: "video/webm", src: videoUrl(props.fullVideoId, { format: 'webm' }) }),
                    React.createElement("source", { type: "video/mp4", src: videoUrl(props.fullVideoId, { format: 'mp4' }) })))))));
};
export default withMotionMax(HomepageHeroBannerVideo);
